/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import Hamburger from "./Hamburger"
import Close from "./Close"
import GenericLogo from "./GenericLogo"
import WhiteLogo from "./WhiteLogo"
import MarkLogo from "./MarkLogo"
import LightMarkLogo from "./LightMarkLogo"
import { Link, navigate } from "gatsby"

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showMenu: false };
  }

  toggleMenu = () => {
    this.setState({
      showMenu: !this.state.showMenu
    });
  }

  render() {
    const {
      children,
      data,
      noContainer,
      noFooter = false,
      location,
      hideDesktopMenuItems = false,
    } = this.props;

    console.log(location);

    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <div className="root-container dark">
            {this.state.showMenu && (
              <div className="mobile-menu-container">
                <div className="nav-container">
                  <div style={{display: "flex", flex: "1 1 auto", "alignItems": "center"}}>
                    <div className="desktop-logo">
                      <GenericLogo />
                    </div>
                    <div className="mobile-logo" style={{ width: "100%", maxWidth: 300, marginRight: 10}}>
                      <GenericLogo />
                    </div>
                  </div>
                  <div className="close-menu" onClick={this.toggleMenu} onTouch={this.toggleMenu}>
                    <Close />
                  </div>
                </div>
                <div className="mobile-menu">
                  <Link className="nav-item" activeClassName="active" to={`/${location}`}>Experiences</Link>
                  <Link className="nav-item" to={`/${location}/book-now`}>Gift Vouchers</Link>
                  <Link className="nav-item" activeClassName="active" to={`/${location}/faq/`}>FAQ</Link>
                  <Link className="nav-item" activeClassName="active" to={`/${location}/events`}>Events</Link>
                  <Link className="nav-item" activeClassName="active" to={`/${location}/contact`}>Contact</Link>
                  <div style={{ display: "flex", flex: "1 1 auto", alignItems: "flex-end", marginBottom: 20 }}>
                    <div style={{ width: "100%", display: "flex", flexDirection: "column", flex: "1 1 auto" }}>
                      <label className="city-label-mobile" for="city-dropdown">Location</label>
                      <select class="nav-item-dropdown" name="city-dropdown" style={{ flex: "1 1 auto", marginLeft: 0, height: 38 }} onChange={(e) => {
                        if (e.target.selectedIndex === 1) {
                          navigate("/townsville");
                        } else if (e.target.selectedIndex === 2) {
                          navigate("/cairns");
                        }
                      }}>
                        <option value="" disabled={true} selected={!location}>Select a city</option>
                        <option value="townsville" selected={location === "townsville"}>Townsville</option>
                        <option value="cairns" selected={location === "cairns"}>Cairns</option>
                      </select>
                    </div>
                  </div>
                  <div style={{display: "flex", marginBottom: 40}}>
                    <Link className="button button-primary" to={`/${location}/book-now`} style={{ marginBottom: 0, flex: "1 1 auto" }}>Book Now</Link>
                  </div>
                </div>
              </div>
            )}
            <div
              className="container"
            >
              <div className="nav-container">
                <div style={{display: "flex", flex: "1 1 auto", "alignItems": "center"}}>
                  <Link to="/" style={{ flex: "1 1 auto", maxWidth: 300 }}>
                    <div className="desktop-logo">
                      <GenericLogo />
                    </div>
                    <div className="mobile-logo">
                      <LightMarkLogo />
                    </div>
                  </Link>
                  <select class="nav-item-dropdown mobile-hidden" style={{ marginLeft: 30, height: 38 }} onChange={(e) => {
                    if (e.target.selectedIndex === 1) {
                      navigate("/townsville");
                    } else if (e.target.selectedIndex === 2) {
                      navigate("/cairns");
                    }
                  }}>
                    <option value="" disabled={true} selected={!location}>Select a city</option>
                    <option value="townsville" selected={location === "townsville"}>Townsville</option>
                    <option value="cairns" selected={location === "cairns"}>Cairns</option>
                  </select>
                </div>
                <div className="hamburger-menu" onClick={this.toggleMenu}>
                  <Hamburger />
                </div>
                {
                  !hideDesktopMenuItems && (
                    <div className="desktop-menu">
                      <Link className="nav-item" activeClassName="active" to={`/${location}`}>Experiences</Link>
                      <Link className="nav-item" to={`/${location}/book-now`}>Gift Vouchers</Link>
                      <Link className="nav-item" activeClassName="active" to={`/${location}/faq/`}>FAQ</Link>
                      <Link className="nav-item" activeClassName="active" to={`/${location}/how-it-works/`}>How It Works</Link>
                      <Link className="nav-item" activeClassName="active" to={`/${location}/events/`}>Events</Link>
                      <Link className="nav-item" activeClassName="active" to={`/${location}/contact/`}>Contact</Link>
                      <Link className="button button-primary" to={`/${location}/book-now`} style={{ marginBottom: 0 }}>Book Now</Link>
                    </div>
                  )
                }
              </div>
            </div>
            <div className={noContainer ? '' : 'container'}>
              <div style={{ minHeight: "80vh" }} className={`main-content ${this.state.showMenu ? 'mobile-hidden' : ''}`}>
                {children}
              </div>
              {
                !noFooter && (
                  <footer style={{ marginTop: 20, marginBottom: 30 }}>
                    © {new Date().getFullYear()}, Escape Academy
                  </footer>
                )
              }
            </div>
          </div>
        )}
      />
    )
  }
}
/*
Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
*/
